export interface TrackingMetadata {
  user_id?: string;
  client_id?: string;
  source: 'search_results' | 'chatbot';
  url?: string;
}

export interface TrackingDataInput {
  trackingData: any | null;
  authType: string | undefined;
  source: 'search_results' | 'chatbot';
}

/**
 * Builds tracking metadata for AnswerAI API calls.
 * Used by both AI Search (prediction API) and Chatbot (aai-embed).
 * Keeps tracking fields in sync across both integrations.
 */
export function getTrackingMetadata({
  trackingData,
  authType,
  source
}: TrackingDataInput): TrackingMetadata {
  let user_id: string | undefined;
  let client_id: string | undefined;

  if (authType === 'Okta') {
    // For Okta: user ID is extracted from JWT token (uid) and added to session.user.id
    // client_id is extracted from JWT token (cid) and added to session.client_id
    user_id = trackingData?.user?.id;
    client_id = trackingData?.client_id;
  } else {
    // For non-Okta auth: user ID is in trackingData.userId
    user_id = trackingData?.userId;
    client_id = trackingData?.client_id;
  }

  // Get current URL (client-side only)
  const url = typeof window !== 'undefined' ? window.location.href : undefined;

  return {
    user_id,
    client_id,
    source,
    url
  };
}

export default getTrackingMetadata;
